import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
   {
    path: '/Gaschoise',
    component : () => import('@/views/Gaschoise.vue'),
    meta:{
      title:'燃气用户老旧改预约'
    }
  },
   {
    path: '/GPGasInput',
    component : () => import('@/views/GPGasInput.vue'),
    meta:{
      title:'天然气用户老旧改预约'
    }
  },
     {
    path: '/GPLPGInput',
    component : () => import('@/views/GPLPGInput.vue'),
    meta:{
      title:'液化气用户老旧改预约'
    }
  },
  {
    path: '/gscheck',
    component : () => import('@/views/gscheck.vue'),
    meta:{
      title:'南宁中燃工商安检'
    }
  },
  {
    path: '/yytquestion',
    component : () => import('@/views/yytquestion.vue'),
    meta:{
      title:'营业厅答题系统'
    }
  },
    {
    path: '/yytquestionlist',
    component : () => import('@/views/yytquestionlist.vue'),
    meta:{
      title:'营业厅答题列表'
    }
  },
    {
      path: '/point',
      component : () => import('@/views/point.vue'),
      meta:{
        title:'南宁中燃附近充值点'
      }
    },
    {
      path: '/Emp',
      component : () => import('@/views/Emp.vue'),
      meta:{
        title:'上门服务人员身份查验'
      }
    },
    {

      path: '/answer',
      component : () => import('@/views/answer.vue'),
      meta:{
        title:'燃气安全知识问答'
      }
    },
    {

      path: '/Excel',
      component : () => import('@/views/Excel.vue'),
      meta:{
        title:'AI数据上报汇总'
      }
    },
    {

      path: '/showExcel',
      component : () => import('@/views/showExcel.vue'),
      meta:{
        title:'AI数据上报汇总列表'
      }
    },
    {
      name:'ninegrid',
      path: '/ninegrid',
      component : () => import('@/views/ninegrid.vue'),
      meta:{
        title:'抽奖'
      }
    },
    {
      path: '/BigWheel',
      component : () => import('@/views/BigWheel.vue'),
      meta:{
        title:'抽奖'
      }
    },
    {
      path: '/notise',
      component : () => import('@/views/notise.vue'),
      meta:{
        title:'南宁中燃停气查询'
      }
    },
    {
      path: '/chat',
      component : () => import('@/views/chat.vue'),
      meta:{
        title:'南宁中燃智能客服'
      }
    },
    {
      path: '/chatold',
      component : () => import('@/views/chatold.vue'),
      meta:{
        title:'南宁中燃智能客服'
      }
    },
    {
      path: '/checkfinish',
      component : () => import('@/views/checkfinish.vue'),
      meta:{
        title:'安检完成'
      }
    },
    {
      path: '/layout',
      component : () => import('@/views/layout.vue'),
      meta:{
        title:'布局'
      }
    },
    {
      path: '/newnotise',
      component : () => import('@/views/newnotise.vue'),
      meta:{
        title:'南宁中燃停气查询'
      }
    },
    {
      path: '/Header',
      component : () => import('@/components/Header.vue'),
      meta:{
        title:'南宁中燃停气查询'
      }
    },
    {
      path: '/Vant',
      component : () => import('@/views/notise.vue'),
      meta:{
        title:'南宁中燃停气查询'
      }
    },
    {
      path: '/RankingPage',
      component : () => import('@/views/RankingPage.vue'),
      meta:{
        title:'2025年全区住建领域培训考核技能竞赛实时成绩排名'
      }
    },
    {
      path: '/AdminPage',
      component : () => import('@/views/AdminPage.vue'),
      meta:{
        title:'后台管理页面'
      }
    },
    {
      path: '/test',
      component : () => import('@/views/test/index.vue')
    },
    {
      path: '/login',
      component : () => import('@/views/Login.vue')
    }
   
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
